export const useStoreEvents = defineStore('StoreEvents', {
    state: () => ({
        events: null,
        hasMore: null,
        error: null,
        filter: {
            paginate: {
                start: 0,
                limit: 35,
            },
            order: [{field: 'id_event', asc: true}],
            fields: {
                eventSlug: [
                    'west-coast-swing-classes-leeds', // Headingley Tuesdays
                    'beginner-bootcamp',
                    'progressive-workshop',
                ],
            },
        },
    }),
    actions: {
        async getEvents() {
            this.error = null;
            ({events: this.events, error: this.error, hasMore: this.hasMore} = await useQueryEvents().get(this.filter));
        },
    },
});
